import axios from 'api/axios'
import { ClientProfile, Plan, SingleClientProfileDashboard } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface for the Response object you get from getSingleClients request if successful
 */
export interface GetSingleClientResponse {
	clientProfile: ClientProfile
	dashboard: SingleClientProfileDashboard
	planHistory: Plan[] | []
}

export const getSingleClient = async (
	id: string
): Promise<GetSingleClientResponse> => {
	try {
		const { data } = await axios.get<GetSingleClientResponse>(`client/${id}`)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getSingleClient
